// extracted by mini-css-extract-plugin
export default {"root":"modules__uilab__components__vertical-list__root","item":"modules__uilab__components__vertical-list__item"};